import React from 'react';

export const MinusIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="2" fill="none" viewBox="0 0 7 2">
            <path fill="#2B2929" d="M0 1.5h7V0H0v1.5z"></path>
        </svg>
    );
};
